import { render } from "./ThankYou.vue?vue&type=template&id=486110b0&scoped=true"
const script = {}

import "./ThankYou.vue?vue&type=style&index=0&id=486110b0&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486110b0"]])

export default __exports__